import * as apiGetUserSettingKey from 'api/userSetting/GetUserSettingKeyV1';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';

export type PreferredNutrients = string[];

export async function getPreferredNutrients(): Promise<PreferredNutrients> {
	const userPreferredNutrientIds = await apiGetUserSettingKey.callApi('Preferred.Nutrient.Ids');

	return userPreferredNutrientIds
		.map((x) => {
			if (x) return x.split(';');
			return [];
		})
		.getOrDefault([]);
}

const rb = new ReducerBuilder<PreferredNutrients>();
export const preferredNutrientsLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'PreferredNutrients/LoadedFromBackend'
);

export const setReduxPreferredNutrientIds = rb.createActionForReducer(
	payloadReducer((x) => x),
	'PreferredNutrients/SET'
);
export const preferredNutrientsReducer = rb.createReducer();
